import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
    content: {
        flexDirection: "column",
        paddingHorizontal: 25,
    },
    contentBtn: {
        position: 'absolute',
        bottom: 50,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    },
    token_header_container: {
        marginTop: 25,
        alignItems: "center",
        justifyContent: "center",
        height: 100
    },
    token_header_title: {
        fontSize: 16,
        fontWeight: "bold",
        color: "#2C2C2E",
        marginBottom: 5
    },
    token_header_image: {
        width: 65,
        height: 65,
        borderRadius: 65,
        borderWidth: 0,
        borderColor: "#32BFB1",
        borderRadius: 50
    },
    contentCheckbox: {
        flexDirection: 'row',
        position: 'absolute',
        bottom: 115,
        paddingHorizontal: 25,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    contentPrices: {
        alignItems: "center",
        marginTop: 10
    },
    descriptionPrice: {
        fontSize: 16,
        color: '#939394'
    },
    price: {
        color: '#000',
        fontWeight: 'bold'
    },
    contentPriceSell: {
        flexDirection: 'row',
    },
    textInputPriceSell: {
        borderBottomColor: '#939394',
        borderBottomWidth: 2,
        marginBottom: 30,

    },
    contentAmount: {
        height: 100
    },
    textInputAmount: {
        borderBottomColor: '#939394',
        borderBottomWidth: 2,
        marginBottom: 30,
        fontSize: 16
    },
    titlePage: {
        fontSize: 16,
        color: "#222",
        paddingVertical: 10,
        flex: 1
    },
    coin: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#fff',
        backgroundColor: '#3A3A3C',
        height: 25,
        padding: 3
    },
    textInfoPriceSell: {
        fontSize: 16,
        color: '#000',
        fontWeight: 'bold',
        marginTop: Platform.OS === 'ios' ? 0 : 5
    }
});

export default styles;
